import { Injectable } from "@angular/core";
import { FormControlStatus, FormGroup } from "@angular/forms";
import {
  BaseFpxFormHelper,
  BaseFpxComponentState,
  BaseFpxChangeHandler,
} from "@common/base-components";
import { EAccountServiceCode } from "@common/models";
import { ResultService } from "@common/services";
import { IHttpErrorPayload, IHttpSuccessPayload } from "@core/models";
import { AccountsService } from "src/app/services/accounts/accounts.service";
import { IDdrequest, IRequestDDContext, IRequestDDPayload } from "../models/request-dd.model";
import { RequestDdService } from "./request-dd.service";

export class RequestDDState implements BaseFpxComponentState {
  activeDebitAccountNumber: string;
  disableMode: boolean;
}

@Injectable()
export class RequestDDHelper extends BaseFpxFormHelper<RequestDDState> {

  constructor(private _requestDdService: RequestDdService,
    private _accountsService: AccountsService,
    private _resultService: ResultService) {
    super(new RequestDDState());
    // this.addChangeHandler("currency", this.doCurrencyChange);
    // this.addChangeHandler("payableState", this.doPayableStateChange);
    this.addChangeHandler("accountNumber", this.doCardChange)
    // this.addChangeHandler("amount", this.doAmountChange);
    this.addChangeHandler("beneId", this.dobeneIdChange);
    this.addChangeHandler("beneName", this.dobeneNameChange);

  }

  // private doCurrencyChange: BaseFpxChangeHandler = (name: string, status: FormControlStatus, value: any, formGroup: FormGroup) => {
  //   formGroup.controls['exchangeRate'].reset();
  //   formGroup.patchValue({
  //     'amount': {
  //       'currencyCode': value
  //     }
  //   });
  //   formGroup.controls["amount"].patchValue(null);

  // }
  // private doPayableStateChange: BaseFpxChangeHandler = (name: string, status: FormControlStatus, value: any, formGroup: FormGroup) => {
  //   formGroup.controls['payableCity'].reset();
  // }

  private doCardChange: BaseFpxChangeHandler = (name: string, status: FormControlStatus, value: any, formGroup: FormGroup) => {
    if (value) {
        this.state.activeDebitAccountNumber = value;
    } else {
        this.state.activeDebitAccountNumber = '';
    }
    formGroup.controls['beneName'].reset();
    formGroup.controls['beneId'].reset();
    formGroup.controls['issueDate'].reset();
    // formGroup.controls['currency'].reset();
    formGroup.controls['amount'].reset();
    formGroup.controls['exchangeRate']?.reset();
    formGroup.controls['payableState']?.reset();
    formGroup.controls['payableCity']?.reset();
     formGroup.controls['dlvryBranch'].reset();
    formGroup.controls['remarks'].reset('',{emitEvent : false});

  }
  fetchDdDetails(requestReference, formGroup: FormGroup) {
    this._requestDdService.fetchDdDetails(requestReference).subscribe(
      (res: IDdrequest)=> {
        let date = res.issueDate.split('-');
        let formatdate = date[2]+'-'+date[1]+'-'+date[0];
            formGroup.patchValue({
                'accountNumber': res.accountNumber,
                'beneName': res.beneName,
                'beneId': res.beneId,
                'issueDate': formatdate,
                'amount': {
                            'amount': res.amount.toString(),
                            'currencyCode': res.currency
                          },
                'dlvryOption': res.dlvryOption,
                'dlvryBranch': res.dlvryBranch,
                'remarks': res.remarks

            }, { emitEvent: false });
            formGroup.disable({ emitEvent: false });
            this.state.disableMode=true;
        },
        (err)=> {

        }
    );
}
  public doConfirm(context: IRequestDDContext, success: any, failure: any) {
    console.log("Context data:", context);
    const requestDd = this._setRequestDdPayload(context);
    this._requestDdService.createRequestDd(requestDd).subscribe(
      (res: any) => {
        let additionalFields = {
          'referenceNumber': res.refNo?res.refNo:res.inventoryNo
          }
        this._resultService.setSuccess(
          res,
          EAccountServiceCode.REQUEST_DD,
          additionalFields
        );
        success(res);
      },
      (err: IHttpErrorPayload) => {
        this._resultService.setFailure(
            err,
            true,
        );
        failure(err);
      }
    );
  }

  private _setRequestDdPayload(context: IRequestDDContext): IRequestDDPayload {
    const requestDd: any = {
      ddrequest: { ...context },
    };
    requestDd.ddrequest.amount = Number(context?.amount?.amount);
    requestDd.ddrequest.currency="EGP";
    console.log(requestDd);
    return requestDd;
  }



  //Bene ID
  dobeneIdChange: BaseFpxChangeHandler = (
    name: string,
    status: FormControlStatus,
    value: any,
    formGroup: FormGroup
  ) => {

    let value1 = formGroup.get("beneId").value?.trimStart();
    formGroup.get("beneId").patchValue(value1, { emitEvent: false });

  };

  //Bene name
  dobeneNameChange: BaseFpxChangeHandler = (
    name: string,
    status: FormControlStatus,
    value: any,
    formGroup: FormGroup
  ) => {

    let value1 = formGroup.get("beneName").value?.trimStart();
    // console.log("After Trimming: ", value1);
    // console.log("Length after trimming:", value1.length);
    formGroup.get("beneName").patchValue(value1, { emitEvent: false });

  };


  resetState(){
    this.state.disableMode=false;
  }

}
